import { Injectable } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { tap } from 'rxjs';

import { GoogleAnalyticsService } from '../analytics';
import { ApiChatsService, ApiNotificationsService } from '../api';
import { UserSite } from '../auth/auth.models';

import { LogsModalComponent } from '../containers/logs-modal/logs-modal.component';
import { NavbarItemEnum } from '../models/app';
import { AppRepository } from './app.repository';

@Injectable({
  providedIn: 'root',
})
export class AppService {
  constructor(
    private appRepo: AppRepository,
    private modalCtrl: ModalController,
    private apiNotification: ApiNotificationsService,
    private apiChat: ApiChatsService,
    private googleAnalyticsService: GoogleAnalyticsService,
  ) {}

  async openLogsModal() {
    const modal = await this.modalCtrl.create({
      component: LogsModalComponent,
      initialBreakpoint: 1,
    });
    await modal.present();
    await this.googleAnalyticsService.trackPageView('/dev/logs', 'Dev | Logs');
  }

  computeNavbar(site: UserSite, restaurants: { allowOrder: boolean; allowOrderHistory: boolean; hasMenu: boolean; hasFluidite: boolean; hasSurvey: boolean }) {
    const isHomeVisible = site.restaurantsDisplayed;
    this.appRepo.setNavbarItemConfig(NavbarItemEnum.Home, isHomeVisible, isHomeVisible);

    const isOrderVisible = restaurants.allowOrder;
    this.appRepo.setNavbarItemConfig(NavbarItemEnum.Order, isOrderVisible, isOrderVisible);

    const isBookVisible = site.showBooking;
    this.appRepo.setNavbarItemConfig(NavbarItemEnum.Book, isBookVisible, isBookVisible);

    const isHistoryVisible = site.isCashRegisterUsable || restaurants.allowOrderHistory;
    this.appRepo.setNavbarItemConfig(NavbarItemEnum.History, isHistoryVisible, isHistoryVisible);

    const isSurveyVisible = restaurants.hasSurvey;
    this.appRepo.setNavbarItemConfig(NavbarItemEnum.Survey, isSurveyVisible, isSurveyVisible);

    const isReloadVisible = site.isCashRegisterUsable;

    // make a number from the amount of boolean that are true
    const slotsTakenOnNavbar = [isHomeVisible, isOrderVisible, isBookVisible, isHistoryVisible, isSurveyVisible].filter((x) => x).length;

    const isAccountOnNavbar = slotsTakenOnNavbar <= 4;
    const isReloadOnNavbar = slotsTakenOnNavbar <= 3;

    this.appRepo.setNavbarItemConfig(NavbarItemEnum.Reload, isReloadVisible, isReloadOnNavbar);

    // Account is always visible, but we need to know if it's on the navbar or in the header
    this.appRepo.setNavbarItemConfig(NavbarItemEnum.Account, true, isAccountOnNavbar);

    this.appRepo.setNavbarComputed();
  }

  getUnreadChatsCount() {
    return this.apiChat.getUnreadCount().pipe(
      tap((data) => {
        this.appRepo.setChatsCount(data.count);
      }),
    );
  }

  getNotificationsCount() {
    return this.apiNotification.getUnreadCount().pipe(
      tap((data) => {
        this.appRepo.setNotificationsCount(data.count);
      }),
    );
  }
}
